module.exports = __webpack_public_path__ + "img/mail.e799a583.svg";